import { MAX_FILE_SIZE } from "@vega-core/constants/global";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type DataRoomDropZoneProps = {
  isEmpty: boolean;
  hasProspects: boolean;
  isRootDragOver: boolean;
  setRootDropEl: (rootDropEl: HTMLTableCellElement | null) => void;
  readOnly?: boolean;
};

export function DataRoomDropZone({
  isEmpty,
  hasProspects,
  isRootDragOver,
  setRootDropEl,
  readOnly = false,
}: DataRoomDropZoneProps) {
  if (readOnly && !isEmpty) return null;

  return (
    <div
      className={cnTwMerge(
        "flex flex-col items-center justify-center gap-1 border border-dashed border-border/primary p-2",
        isEmpty ? "h-44" : "h-20",
        isRootDragOver && "bg-background/brand/opacity",
      )}
      data-testid="data-room-root-drop-zone"
      ref={setRootDropEl}
    >
      {isEmpty && !isRootDragOver ? (
        <div className="mb-3 flex flex-col items-center gap-1">
          <p className="body-base-medium text-text/primary">
            {m.coInvestments_dataRoom_emptyState()}
          </p>
          {!hasProspects && (
            <p className="body-small-regular text-text/secondary">
              {m.coInvestments_dataRoom_emptyStateProspects()}
            </p>
          )}
        </div>
      ) : null}
      {readOnly ? null : (
        <>
          <p className="body-base-regular text-text/secondary">
            {m.coInvestments_dataRoom_dropFilesHere()}
          </p>
          <p className="body-small-regular text-text/tertiary">
            {m.coInvestments_dataRoom_dropZoneHint({
              maxSizeMB: String(MAX_FILE_SIZE / (1024 * 1024)),
            })}
          </p>
        </>
      )}
    </div>
  );
}
